/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/PayerInfo/Installment/Content/Expandable/Content/LastInstallment/Content"
  
}) {
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let payerDataLastInstallmentValueData = fromData.useDataFormat({ viewPath,
context: 'payer',
path: 'data.last_installment',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 fontSize={11}
 text="Last installment"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={11}
 weight="medium"
 data="payer.data.last_installment"
 format="/Data/format.js numberMoney"
 text={payerDataLastInstallmentValueData}
/>
{children}
</React.Fragment>)
}